<!------------------------------------------------------------------------------
  Copyright (c) 2020. keni

  This file PerformanceTest.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  PerformanceTest.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->

<template>
    <div>
        <div class="m-1 d-flex flex-sm-row flex-column justify-content-end align-content-center">
            <h1>Total Requested: <span class="p-2">{{requested}}</span></h1>
            <a class="btn btn-primary active"
               :class="{
                        'btn-primary':!debug_mode,
                        'btn-secondary':debug_mode,
                       }" :href="get_switch">Performance Test</a>
        </div>
        <div class="d-flex flex-sm-row flex-column justify-content-end align-content-center">

            <div class="btn btn-primary" v-on:click="execute(add)">Add {{number_of_requests}} per user Test</div>
            <div class="btn btn-primary" v-on:click="execute(home)">Home {{number_of_requests}} per user Test</div>
        </div >
        <div class="container-fluid">
            <ul class="row">
                <li class="col-1" v-for="(msg,index) in messages" v-bind:key="'msg-'+index">
                    <span>{{msg}}
                    </span>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>

    const axios = require('axios');
    export default {
        name: "PerformanceTest",
        props:{
            debug_mode:{
                type:Boolean,
                default:false
            },
            performance_switch: {
                type: String,
                default: '/'
            },
        },
        data() {
            return {
                add: {
                    url:'/basket/add/209',
                    method:'post'
                },
                home:{
                    url:'/',
                    method:'get'
                },
                messages: [],
                users: {},
                number_of_requests: 50,
                requested:0,
                requests:{

                }
            };
        },
        mounted() {
            for (let i = 0; i < this.number_of_requests; i++) {
                this.requests[i] = {
                    start:null,
                    end:null,
                    total:null,
                    axios_flag:null
                }
            }
        },
        methods: {
            setCookie(name, value, days) {
                let expires = "";
                if (days) {
                    var date = new Date();
                    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                    expires = "; expires=" + date.toUTCString();
                }
                document.cookie = name + "=" + (value || "") + expires + "; path=/";
            },
            getCookie(name) {
                let nameEQ = name + "=";
                let ca = document.cookie.split(';');
                for (let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
                }
                return null;
            },
            eraseCookie(name) {
                document.cookie = name + '=; Max-Age=-99999999;';
            },
            delete_cookie(name) {
                window.document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            },
            loopThis(data){
                for (let i = 0; i < this.number_of_requests; i++) {
                    this.requester(i,data);
                }
            },
            newUser() {
                this.eraseCookie('__stripe_mid');
                this.eraseCookie('__stripe_sid');
                this.eraseCookie('XSRF-TOKEN');
                this.eraseCookie('est_cookie_consent');
                this.eraseCookie('laravel_session');
                console.log('document.cookie', this.getCookie('laravel_session'));
            },
            testSession(){
                this.eraseCookie('laravel_session');
            },
            execute(data) {
                this.messages.push('started');
                this.loopThis(data);
            },

            async requester(iterator,data) {
                let self = this;

                self.requests[iterator].start = new Date().getTime();
                self.requests[iterator].axios_flag =  axios;

                self.requests[iterator].axios_flag.defaults.withCredentials = true;

                self.requests[iterator].axios_flag[data.method](data.url)
                    .then(response => {
                        // handle success
                        // console.log('cookie',response.config.headers)

                        // let token = response.config.headers['X-XSRF-TOKEN'];
                        //
                        // // build users by token supplied
                        // if (!Object.prototype.hasOwnProperty.call(self.users, token)) {
                        //     self.users[token] = {
                        //         token: token
                        //     }
                        // }
                        // console.log(response.data)
                        // self.messages.push(response.data.basket.items)
                    })
                    .catch(function (e) {
                        console.log(e)
                    })
                    .then(function () {
                        self.requested = self.requested + 1;
                        //always executed
                        self.requests[iterator].end = new Date().getTime();
                        self.requests[iterator].total = (self.requests[iterator].end - self.requests[iterator].start)/1000;
                        self.messages.push(self.requests[iterator].total);
                    });
            },
        },
        computed:{
            get_switch(){
                return this.performance_switch;
            }
        }
    }
</script>

<style scoped>
    ul {
        list-style-type: none;
    }

    li {
        margin: 1em;
        text-align: left;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/layouts/PerformanceTest.vue